"use client";

import { Link } from "@i18n/routing";
import type React from "react";
import { getCookie } from "cookies-next";
import {
  PostHostEventsEnum,
  sendPostHogEvent,
} from "../../../app/libs/post-hog/post-hog-send-event";

type BadgeProps = {
  name: string;
  url: string;
};

const Badge: React.FC<BadgeProps> = ({ name, url }) => {
  const handleClickBadge = async () => {
    const email = (await getCookie("leadEmail")) ?? undefined;

    sendPostHogEvent({
      eventName: PostHostEventsEnum.FILTER_EVENT,
      email: email,
      eventProperties: {
        badgeName: name,
        badgeUrl: url,
      },
    });
  };

  return (
    <div className="box-border mb-2 p-0 outline-[none] text-[100%] [list-style:none] mr-[8px]">
      <Link
        href={url || "#"}
        className="box-border text-[rgb(5,_11,_32)] no-underline font-medium cursor-pointer bg-white hover:bg-slate-900 hover:text-white [transition:0.3s] m-0 py-[10px] px-[15px] border-[1px]  outline-[none] text-[100%] rounded-[16px] inline-block"
        onClick={handleClickBadge}
      >
        {name}
      </Link>
    </div>
  );
};

export default Badge;
